import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  signInAnonymously,
  type User,
} from "firebase/auth";
import {
  getFirestore,
  connectFirestoreEmulator,
} from "firebase/firestore";
import { initRuntimeInfo } from "@/debug/runtimeInfo";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

const devWantsEmul =
  import.meta.env.DEV &&
  (import.meta.env.VITE_USE_EMULATOR === "true" ||
    import.meta.env.VITE_USE_EMULATORS === "true" ||
    (typeof localStorage !== "undefined" && localStorage.getItem("qq_useEmul") === "1"));

export const useEmulator = !!devWantsEmul;

let dbHost = "firestore.googleapis.com";
if (useEmulator) {
  const host = import.meta.env.VITE_EMULATOR_HOST ?? "127.0.0.1";
  const port = Number(import.meta.env.VITE_EMULATOR_PORT ?? "8080");
  try {
    connectFirestoreEmulator(db, host, port);
    dbHost = `${host}:${port}`;
    (globalThis as any).__QQ_FS_HOST__ = host;
    (globalThis as any).__QQ_FS_PORT__ = port;
  } catch {
    // ignore in prod
  }
}

initRuntimeInfo({
  projectId: firebaseConfig.projectId,
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  db,
  dbHost,
  usingEmulator: useEmulator,
  auth,
});
(globalThis as any).qqDb = db;

/** Ensure a signed-in user (anonymous if necessary). Resolves to the current User. */
export async function ensureAuth(): Promise<User> {
  if (auth.currentUser) return auth.currentUser;
  await new Promise<void>((resolve) => {
    const unsub = onAuthStateChanged(auth, () => {
      unsub();
      resolve();
    });
  });
  if (!auth.currentUser) {
    console.warn('[ensureAuth] No user found, signing in anonymously...');
    await signInAnonymously(auth);
  }
  return auth.currentUser!;
}


